import React from 'react';
import { ProductListPageResultFragment } from '../../generated/types/ProductListPageResultFragment';
import { GuidePageQuery_displayPage as DisplayPage } from '../../generated/types/GuidePageQuery';
import { SortOption } from '../../constants';
import { PLPBreadcrumbs } from '../PLPBreadcrumbs';
import { GridItemCount } from '../GridPeripherals/GridItemCount';
import { SalePercentageTags } from '../SalePercentageTags/SalePercentageTags';
import { ProductListingMobileFilter } from './ProductListingMobileFilter';
import { ProductListingMobileSort } from './ProductListingMobileSort';

import './ProductListingMobile.scss';

interface ProductListingMobileProps {
  availableSorts: SortOption[];
  currentSort: SortOption;
  headerText: string;
  onSortChanged: (sort: SortOption['value']) => void;
  queryResult?: ProductListPageResultFragment | null;
  displayPage?: DisplayPage | null;
}

export const ProductListingMobile: React.FC<ProductListingMobileProps> = ({
  availableSorts,
  children,
  currentSort,
  headerText,
  onSortChanged,
  queryResult,
  displayPage
}) => {
  return (
    <div className="ProductListingMobile">
      <PLPBreadcrumbs />

      <div className="ProductListingMobile__header">
        <h1 className="ProductListingMobile__title">{headerText}</h1>
        <GridItemCount
          className="ProductListingMobile__count"
          count={queryResult?.totalItems || 0}
        />
      </div>
      <SalePercentageTags saleTags={queryResult?.saleTags || []} />
      <div className="ProductListingMobile__actions">
        <ProductListingMobileFilter queryResult={queryResult} displayPage={displayPage} />
        <ProductListingMobileSort
          availableSorts={availableSorts}
          currentSort={currentSort}
          onSortChanged={onSortChanged}
        />
      </div>
      {children}
    </div>
  );
};
